// Cliente ocasional: comprador con RNC/cédula que se factura sin estar registrado.
export const OCCASIONAL_NCF = ["E31", "E32"];

export const hasCustomer = (c) => !!(c && (c.id || c.occasional));

export const customerPayload = (c) => (c?.occasional ? {
  customer_id: null,
  customer_name: c.name,
  customer_rnc_cedula: c.rnc_cedula,
  occasional_buyer: true,
  save_occasional: !!c.save_occasional,
} : {
  customer_id: c?.id || null,
  customer_name: c?.name || "Cliente Genérico",
  customer_rnc_cedula: c?.rnc_cedula || "",
  occasional_buyer: false,
  save_occasional: false,
});

export const occasionalFromDoc = (d) => ({
  id: null, occasional: true, name: d.customer_name, rnc_cedula: d.customer_rnc_cedula || "",
  save_occasional: !!d.save_occasional,
});
